module.exports = __webpack_public_path__ + "media/images/logos/Princeton-University-4b292feb86500fe3e2a39e315db0b966.svg";